import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

/**
 * Expandable order line-item detail for inventory receiving reports
 */
export const OrderItemsDetail = ({ data }) => {
  const orderItems = data?.order_items || [];

  if (!orderItems.length) {
    return (
      <Box sx={{ px: 1, py: 2 }}>
        <Typography variant="body2" color="text.secondary">
          No items found for this order.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography
        variant="body2"
        fontWeight={700}
        sx={{ mb: 1.25, color: "text.primary" }}
      >
        Order Items ({orderItems.length} item
        {orderItems.length !== 1 ? "s" : ""})
      </Typography>
      <TableContainer
        sx={{
          border: "1px solid",
          borderColor: "divider",
          borderRadius: "6px",
          bgcolor: "background.paper",
          overflow: "hidden",
        }}
      >
        <Table size="small" aria-label="order items detail">
          <TableHead
            sx={{
              bgcolor: "secondary.main",
              borderBottom: "1px solid",
              borderColor: "primary.main",
              "& .MuiTableCell-head": {
                color: "common.white",
                fontWeight: 600,
                fontSize: "0.75rem",
                py: 1,
                whiteSpace: "nowrap",
              },
            }}
          >
            <TableRow>
              <TableCell>Product</TableCell>
              <TableCell>Brand</TableCell>
              <TableCell>Category</TableCell>
              <TableCell align="center">Quantity</TableCell>
              <TableCell align="right">Unit Cost</TableCell>
              <TableCell align="right">Total Cost</TableCell>
              <TableCell>UPC Code</TableCell>
              <TableCell>Notes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orderItems.map((item, index) => {
              const qty = Number(item.order_item_product_amount || 0);
              const unitCost = Number(item.product?.product_cost || 0);
              const lineTotal = qty * unitCost;

              return (
                <TableRow
                  key={item.order_item_id || index}
                  sx={{
                    "&:nth-of-type(odd)": {
                      bgcolor: (theme) =>
                        theme.palette.mode === "dark" ? "#1b1b1e" : "#fafafa",
                    },
                    "&:nth-of-type(even)": {
                      bgcolor: (theme) =>
                        theme.palette.mode === "dark" ? "#141416" : "transparent",
                    },
                    "& td": {
                      py: 1,
                      verticalAlign: "top",
                      color: "text.primary",
                      borderColor: "divider",
                    },
                  }}
                >
                  <TableCell>{item.product?.product_name || "N/A"}</TableCell>
                  <TableCell>{item.product?.brand_name || "N/A"}</TableCell>
                  <TableCell>{item.product?.category_name || "N/A"}</TableCell>
                  <TableCell align="center">
                    <Typography variant="body2" fontWeight={600}>
                      {qty}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="body2" fontWeight={600}>
                      ${unitCost.toFixed(2)}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="body2" fontWeight={700}>
                      ${lineTotal.toFixed(2)}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="body2"
                      sx={{ fontFamily: "monospace", fontSize: "0.8rem" }}
                    >
                      {item.product?.product_upc_code || "N/A"}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" color="text.secondary">
                      {item.order_item_note || ""}
                    </Typography>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
